var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-document-form" },
    [
      _c(
        "form-accordion",
        { attrs: { title: _vm.$t("businessDocuments.request_desc_read") } },
        [
          _vm.document.Description !== ""
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "form-group col-sm-12" }, [
                  _c("textarea", {
                    staticClass: "form-control inputAccordionForm",
                    staticStyle: { "margin-top": "4px" },
                    attrs: { disabled: "" },
                    domProps: { value: _vm.document.Description },
                  }),
                ]),
              ])
            : _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "form-group col-sm-12" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("common.general_msg_none"))),
                  ]),
                ]),
              ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-md-12",
            staticStyle: { "font-weight": "bold", "font-size": "14px" },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("businessDocuments.form_document_send_title")) +
                "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      !_vm.isSmartphoneOS
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm-12 col-lg-5" }, [
                _vm.locationTypeFile === "1"
                  ? _c("div", { staticClass: "row blackBottomButton" }, [
                      _c(
                        "div",
                        { staticClass: "form-group col-sm-12" },
                        [
                          _c(
                            "f7-button",
                            {
                              staticClass: "invoiceButton buttonAccordionForm",
                              attrs: { round: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.showFileSelectionWindow(
                                    _vm.locationTypeFile
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("attachments.import_file_singular")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "form-group col-sm-12" }, [
                    _vm.locationTypeFile === "2"
                      ? _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fileId,
                                expression: "fileId",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { id: "sel2", readonly: "" },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.fileId = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function ($event) {
                                  return _vm.loadCloudFile()
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "", default: "", disabled: "" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      this.hasCloudAttachments
                                        ? _vm.$t("common.click_to_select_file")
                                        : _vm.$t("attachments.no_document")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.cloudDocs, function (cloudDoc) {
                              return _c(
                                "option",
                                {
                                  key: cloudDoc.id,
                                  domProps: { value: cloudDoc.id },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(cloudDoc.name) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileButton",
                      staticClass:
                        "item-input hiddenElementAllSize local-file-input",
                      attrs: { type: "file" },
                      on: { change: _vm.executeOCR },
                    }),
                    _vm._v(" "),
                    _vm.fileArrayError
                      ? _c("div", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("errors.is_mandatory", {
                                  mandatoryValue: _vm.$t(
                                    "attachments.import_file_singular"
                                  ),
                                })
                              ) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.fileNameArray.length != 0
                ? _c("div", { staticClass: "form-group col-sm-12 col-lg-6" }, [
                    _c(
                      "table",
                      {
                        staticClass: "table table-striped table-bordered",
                        staticStyle: { "table-layout": "fixed" },
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticStyle: { width: "70%" },
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("businessDocuments.document_lst")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v(_vm._s(_vm.$t("common.action_label"))),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(this.fileNameArray, function (filename) {
                            return _c("tr", [
                              _c("td", { staticClass: "textOverflow" }, [
                                _vm._v(_vm._s(filename)),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeFile(filename)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass:
                                          "icon button-delete f7-icons",
                                      },
                                      [_vm._v("close")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "labelDelete" }, [
                                      _vm._v(_vm._s(_vm.$t("common.rm_label"))),
                                    ]),
                                  ]
                                ),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSmartphoneOS
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "button-action-main greenButton",
                    attrs: {
                      round: "",
                      title: _vm.$t("creation_forms.tke_doct_pctr"),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.scanDocument($event)
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("creation_forms.tke_doct_pctr"))),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("span", { staticClass: "labelSub greyLabel" }, [
                _vm._v(_vm._s(_vm.$t("common.or_label_maj"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "button-action-sub greyButton",
                    attrs: {
                      round: "",
                      title: _vm.$t("businessDocuments.local_location_small"),
                      disabled: _vm.$engine.rights.rightIs(
                        "attachment_consulter",
                        false
                      ),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.showFileSelectionWindow("1")
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("businessDocuments.local_location_small"))
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "button-action-sub greyButton",
                    attrs: {
                      round: "",
                      title: _vm.$t(
                        "businessDocuments.moneyroad_location_small"
                      ),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.filesPicker($event)
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("businessDocuments.moneyroad_location_small")
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              this.locationTypeFile != "0" && false
                ? _c("div", { staticClass: "form-group col-sm-6" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("businessDocuments.document_name"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fileNameLabel,
                          expression: "fileNameLabel",
                        },
                      ],
                      staticClass: "form-control inputAccordionForm",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("creation_forms.slct_a_fl"),
                        readonly: "",
                        id: "application-file-input-mobile",
                      },
                      domProps: { value: _vm.fileNameLabel },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.fileNameLabel = $event.target.value
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.fileNameArray.length != 0
                ? _c("div", { staticClass: "form-group col-sm-12" }, [
                    _c("i", [
                      _vm._v(
                        _vm._s(_vm.$t("businessDocuments.othr_pages_label"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        staticClass: "table table-striped table-bordered",
                        staticStyle: { "table-layout": "fixed" },
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticStyle: { width: "70%" },
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("businessDocuments.document_lst")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v(_vm._s(_vm.$t("common.action_label"))),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(this.fileNameArray, function (filename) {
                            return _c("tr", [
                              _c("td", { staticClass: "textOverflow" }, [
                                _vm._v(_vm._s(filename)),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeFile(filename)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass:
                                          "icon button-delete f7-icons",
                                      },
                                      [_vm._v("close")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "labelDeleteMobile" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("common.rm_label"))
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                ref: "fileButton",
                staticClass: "item-input hiddenElementAllSize local-file-input",
                attrs: { type: "file" },
                on: { change: _vm.executeOCR },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("form-write-group-label-input", {
            attrs: {
              inputLabel: _vm.$t("common.rfrnc"),
              placeholderValue: _vm.$t("common.rfrnc"),
            },
            model: {
              value: _vm.fileReference,
              callback: function ($$v) {
                _vm.fileReference = $$v
              },
              expression: "fileReference",
            },
          }),
          _vm._v(" "),
          _c("form-write-group-label-input", {
            attrs: {
              inputLabel:
                _vm.$t("businessDocuments.creation_date") + " (MM-YYYY)",
              placeholderValue: _vm.$t("common.slct_date"),
              regexpErrorIndicator: _vm.creationDateRegexpError,
            },
            model: {
              value: _vm.creationDate,
              callback: function ($$v) {
                _vm.creationDate = $$v
              },
              expression: "creationDate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      this.serializeGet.length != 0
        ? _c(
            "div",
            [
              _c(
                "form-accordion",
                {
                  attrs: {
                    title: _vm.$t("businessDocuments.doc_details"),
                    open: _vm.ocrDone,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _vm._l(_vm.serializeGet, function (value) {
                        return [
                          value.change === "1" ||
                          (value.change === "0" &&
                            _vm.document.Serialize[value.name])
                            ? [
                                value.type === "object"
                                  ? _vm._l(
                                      value[0],
                                      function (subvalue, subindex) {
                                        return _c(
                                          "form-write-group-label-input",
                                          {
                                            key: subindex,
                                            attrs: {
                                              inputLabel: _vm.$t(
                                                "businessDocuments.serialize." +
                                                  _vm.document.Type +
                                                  "." +
                                                  subindex.name
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.document.Serialize[
                                                  value.name
                                                ][0][subindex.name],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.document.Serialize[
                                                    value.name
                                                  ][0],
                                                  subindex.name,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "document.Serialize[value.name][0][subindex.name]",
                                            },
                                          }
                                        )
                                      }
                                    )
                                  : value.type === "date"
                                  ? _c("form-write-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "businessDocuments.serialize." +
                                            _vm.document.Type +
                                            "." +
                                            value.name
                                        ),
                                        placeholderValue:
                                          _vm.$t("common.slct_date"),
                                        inputType: "date",
                                      },
                                      model: {
                                        value:
                                          _vm.document.Serialize[value.name],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.document.Serialize,
                                            value.name,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "document.Serialize[value.name]",
                                      },
                                    })
                                  : value.type === "boolean" &&
                                    value.change === "0"
                                  ? _c(
                                      "div",
                                      { staticClass: "form-group col-sm-6" },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "businessDocuments.serialize." +
                                                  _vm.document.Type +
                                                  "." +
                                                  value.name
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.document.Serialize[value.name] ===
                                        "0"
                                          ? _c("div", [
                                              _c("i", {
                                                staticClass: "icon fa fa-check",
                                                staticStyle: {
                                                  color: "green",
                                                  "font-size": "30px",
                                                },
                                              }),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.status.valid_control_key"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ])
                                          : _c("div", [
                                              _c("i", {
                                                staticClass: "icon fa fa-ban",
                                                staticStyle: {
                                                  color: "red",
                                                  "font-size": "30px",
                                                },
                                              }),
                                              _vm._v("  \n                "),
                                              _vm.document.Serialize[
                                                value.name
                                              ] === "1"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "errors.invalid_control_key"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ])
                                                : _vm.document.Serialize[
                                                    value.name
                                                  ] === "2"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "errors.out_of_date"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ])
                                                : _vm.document.Serialize[
                                                    value.name
                                                  ] === "3"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "errors.invalid_control_key_out_of_date"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]),
                                      ]
                                    )
                                  : _c("form-write-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "businessDocuments.serialize." +
                                            _vm.document.Type +
                                            "." +
                                            value.name
                                        ),
                                      },
                                      model: {
                                        value:
                                          _vm.document.Serialize[value.name],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.document.Serialize,
                                            value.name,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "document.Serialize[value.name]",
                                      },
                                    }),
                              ]
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c("hr"),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-3 justify-content-end" }, [
          _c(
            "button",
            {
              staticClass:
                "button-action firstButtonMarginTop col-md milkyBlockBlack",
              attrs: { round: "" },
              on: { click: _vm.returnBusinessDocument },
            },
            [
              _c("i", { staticClass: "icon fa fa-paper-plane" }),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("businessDocuments.form_document_send_button")
                  ) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c("br"),
          _c("br"),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }